import api from "../../util/api";

/**
 * Facade for Quality Metrics API calls.
 * Wraps logic for building the request and calling the API.
 * Accepts stationCode, startDate, and endDate as parameters.
 */
class QualityApiFacade {
  /**
   * Fetches quality metrics data from the backend.
   * @param {Object} params - Parameters for the API call.
   * @param {string} params.stationCode - Station code.
   * @param {number} params.startDate - Start date (epoch seconds).
   * @param {number} params.endDate - End date (epoch seconds).
   * @param {Function} setAsyncError - Callback for async error handling.
   * @returns {Promise<Object>} - Resolves with API response data.
   */
  static getQualityMetricsData(
    { stationCode, startDate, endDate },
    setAsyncError,
  ) {
    const req = {
      filters: { VIEW_ID: "SORT" },
      metrics: [
        "TOP_EXCEPTIONS",
        "INDUCT_DWELL_INC_PACKAGES",
        "INDUCT_DWELL_JACKPOT_PACKAGES",
        "PSA_TASKS_NORMAL",
        "PSA_TASKS_URGENT",
        "DAMAGED_PACKAGES_PENDING_PS",
        "DAMAGED_PACKAGES_PENDING_STOW_STAGE",
        "DAMAGED_PACKAGES_PENDING_APPROVAL",
        "DAMAGED_PACKAGES_FC_RETURN_DISPOSED",
        "DAMAGED_PACKAGES_RESOLVED",
        "TOTAL_DEFECTS",
        "PS_EFFECTIVENESS",
        "MISDIVERT_DPMO",
        "MISDIVERT_PACKAGES_TOTAL",
        "MISDIVERT_PACKAGES_PENDING_PS",
        "MISDIVERT_PACKAGES_PENDING_RE_INDUCT",
        "MISDIVERT_PACKAGES_RESOLVED",
        "MISAPPLIED_SAL_DPMO",
        "MISAPPLIED_SAL_PACKAGES_TOTAL",
        "MISAPPLIED_SAL_PACKAGES_PENDING_RE_INDUCT",
        "MISAPPLIED_SAL_PACKAGES_RE_INDUCTED",
        "MISSED_INDUCT_DPMO",
        "MISSED_INDUCT_PACKAGES_TOTAL",
        "MISSED_INDUCT_PACKAGES_PENDING_INDUCT",
        "MISSED_INDUCT_PACKAGES_INDUCTED",
        "PENDING_RE_INDUCT_PACKAGES_TOTAL",
        "PENDING_RE_INDUCT_PACKAGES_FROM_RTS",
        "PENDING_RE_INDUCT_PACKAGES_FROM_SIDELINED",
        "PENDING_RE_INDUCT_PACKAGES_FROM_PS",
        "NETWORK_MISSORT_PACKAGES_TOTAL",
        "NETWORK_MISSORT_PACKAGES_PENDING_PS",
        "NETWORK_MISSORT_PACKAGES_PENDING_STOW",
        "NETWORK_MISSORT_PACKAGES_RESOLVED",
      ],
      startDate,
      endDate,
      stationCode,
    };
    return api.GET_QUALITY_METRICS_DATA(req, setAsyncError);
  }
}

export default QualityApiFacade;



// WEBPACK FOOTER //
// ./src/components/quality/common/QualityApiFacade.js